import { render, staticRenderFns } from "./ResultForm.vue?vue&type=template&id=2722a78e&scoped=true&"
import script from "./ResultForm.vue?vue&type=script&lang=js&"
export * from "./ResultForm.vue?vue&type=script&lang=js&"
import style0 from "./ResultForm.vue?vue&type=style&index=0&id=2722a78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2722a78e",
  null
  
)

export default component.exports